import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=2fcf81b5"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports